export default __webpack_public_path__ + "static/media/12.029ed27e.png";